// @ts-nocheck
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { poErrorSelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportApi/ReportAPISelectors";
import { useSelector } from "react-redux";

export const usePoError = () => {
    const dispatch = useBunzlDispatch();
    const poError = useSelector(poErrorSelector);

    const setPoError = (error: boolean) => {
        dispatch({
            type: "Store/Pages/reportAPI/setPoError",
            action: error,
        });
    };

    return [poError, setPoError] as const;
};
